import * as React from 'react';
import type { FeaturedProduct } from '../../types/landing';

interface EduProductsProps {
  products: FeaturedProduct[];
}

export function EduProducts({ products }: EduProductsProps) {
  if (products.length === 0) return null;

  return (
    <section className="edu-products">
      <style>{`
        .edu-products {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .edu-products-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .edu-products h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .edu-products .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 36px;
        }
        .edu-products-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }
        .edu-product-card {
          background: #fff;
          border-radius: 12px;
          border: 1px solid #eee;
          overflow: hidden;
          transition: box-shadow 0.2s;
        }
        .edu-product-card:hover {
          box-shadow: 0 4px 16px rgba(0,0,0,0.08);
        }
        .edu-product-img {
          width: 100%;
          height: 160px;
          object-fit: cover;
          display: block;
          background: #f5f5f5;
        }
        .edu-product-body {
          padding: 14px 16px;
        }
        .edu-product-cat {
          font-size: 12px;
          color: #1EAA25;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          margin: 0 0 4px;
        }
        .edu-product-name {
          font-size: 15px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0 0 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .edu-product-format {
          font-size: 13px;
          color: #888;
        }
        @media (max-width: 768px) {
          .edu-products-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }
          .edu-product-img {
            height: 120px;
          }
        }
        @media (max-width: 480px) {
          .edu-products-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
      <div className="edu-products-inner">
        <h2>Productos destacados</h2>
        <p className="subtitle">Algunos de los productos que más eligen las instituciones educativas</p>
        <div className="edu-products-grid">
          {products.map((product) => (
            <div key={product.id} className="edu-product-card">
              <img
                className="edu-product-img"
                src={product.webp_image_url || product.image_url}
                alt={product.title}
                loading="lazy"
              />
              <div className="edu-product-body">
                <div className="edu-product-cat">{product.category_name}</div>
                <div className="edu-product-name">{product.title}</div>
                {product.default_format && (
                  <div className="edu-product-format">
                    {product.default_format.short_name || product.default_format.name}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
